import { store as createStore } from '@risingstack/react-easy-state'

/**
 * [Store]
 */
const store = createStore({
  initialized: false,
  countries: [],
  map: {},
  initialize,
  getCountryByCode
})

/**
 * [Cache management]
 */

/**
 * [Functions]
 */
function initialize ({ i18n }) {
  const countries = i18n.store.data[i18n.language].common.countries
  const map = {}
  countries.forEach((c) => { map[c[1]] = { name: c[0], code: c[1] } })
  store.map = map
  store.countries = countries
  store.initialized = true
}

function getCountryByCode ({ code }) {
  return store.map[code.toLowerCase()]
}

export default store



// WEBPACK FOOTER //
// ./src/stores/countries.js